import { render, staticRenderFns } from "./FormBeneficiario.vue?vue&type=template&id=0649ea55&scoped=true"
import script from "./FormBeneficiario.vue?vue&type=script&lang=js"
export * from "./FormBeneficiario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649ea55",
  null
  
)

export default component.exports